import { render } from "./EmailSettings.vue?vue&type=template&id=3912ecf4&scoped=true"
import script from "./EmailSettings.vue?vue&type=script&lang=js"
export * from "./EmailSettings.vue?vue&type=script&lang=js"

import "./EmailSettings.vue?vue&type=style&index=0&id=3912ecf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3912ecf4"

export default script